module.exports = __webpack_public_path__ + "img/urbanutvikling_med_paavirkningsgrad.c4bf1a24.jpg";